/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import { Tooltip } from '@mui/material';

import { usePriceItemStyles } from './PriceItem.styles';

type Props = { title: string; isTotal?: boolean; showPrice?: boolean } & (
  | {
      price: { monthly: number; daily: number; currency: string };
    }
  | { unit: string | number }
);

export function PriceItem(props: Props) {
  const { t } = useTranslation();
  const classes = usePriceItemStyles();

  const { showPrice = true } = props;

  const getPriceLabel = (
    amount: string | number,
    currency: string,
    period?: 'day' | 'month',
    fractionDigits: number = 2,
  ) => {
    let result = t('common:format_currency.currency', {
      value: Number(amount).toFixed(fractionDigits),
      currency,
    });

    if (period) {
      result = `${result} ${t(`cluster:price_estimation.periods.per_${period}`)}`;
    }

    return result;
  };

  return (
    <div className={cx(props.isTotal ? classes.total : classes.heading)}>
      {props.title}
      {'unit' in props ? (
        <span className={classes.price}>{props.unit}</span>
      ) : (
        showPrice && (
          <Tooltip title={`${getPriceLabel(props.price.daily, props.price.currency, 'day')}`} placement="right">
            <span className={classes.price}>{getPriceLabel(props.price.monthly, props.price.currency, 'month')}</span>
          </Tooltip>
        )
      )}
    </div>
  );
}
